import {
  DEVELOPER_ARTICLE_LINK,
  docsLinks,
  ENUM_EDITOR_LINK,
  FUNCTIONS_LINK,
  HOWTO_ACCESS_PUBLIC_API_FROM_FUNCTION,
  HOWTO_CREATE_CUSTOM_FIELD_LINK,
  HOWTO_CREATE_CUSTOMIZE_TABLE_LINK,
  HOWTO_TEST_FUNCTION,
} from '../../../../../constants/values';
import { DocumentationLinksT } from './types';

const codeEditor = [
  {
    translation: 'overviewArticle',
    link: FUNCTIONS_LINK,
    icon: 'textSubject',
  },
  {
    translation: 'developerArticle',
    link: DEVELOPER_ARTICLE_LINK,
    icon: 'textSubject',
  },
  {
    translation: 'howToAccessInternet',
    link: HOWTO_ACCESS_PUBLIC_API_FROM_FUNCTION,
    icon: 'textSubject',
  },
  {
    translation: 'howToTestFunction',
    link: HOWTO_TEST_FUNCTION,
    icon: 'textSubject',
  },
  {
    translation: 'apiDocumentation',
    link: docsLinks.codeEditorApiDocs,
    icon: 'codeTags',
  },
] as const satisfies ReadonlyArray<DocumentationLinksT>;

const schemaEditor = [
  {
    translation: 'howToCustomField',
    link: HOWTO_CREATE_CUSTOM_FIELD_LINK,
    icon: 'textSubject',
  },
  {
    translation: 'howToCustomTable',
    link: HOWTO_CREATE_CUSTOMIZE_TABLE_LINK,
    icon: 'textSubject',
  },
  {
    translation: 'howToEnumField',
    link: ENUM_EDITOR_LINK,
    icon: 'textSubject',
  },
  {
    translation: 'schemaDocumentation',
    link: docsLinks.schema,
    icon: 'codeTags',
  },
] as const satisfies ReadonlyArray<DocumentationLinksT>;

export const documentationLinksConfig = {
  codeEditor,
  schemaEditor,
};
